module.exports = __webpack_public_path__ + "static/media/paypal.65e7d973.svg";